import { ManageLibraries } from "../../../components";

export const ManageLibrariesPage: React.FC = () => {
  return <ManageLibraries />;
};
